import React from 'react';
import { FaUserGraduate, FaChalkboardTeacher, FaLayerGroup, FaMoneyBillWave } from 'react-icons/fa';

export default function AdminStats({ stats }) {
    const cards = [
        {
            title: 'Total Students',
            value: stats.students,
            icon: <FaUserGraduate />,
            color: 'blue',
            bg: 'bg-blue-100',
            text: 'text-blue-600'
        },
        {
            title: 'Total Teachers',
            value: stats.teachers,
            icon: <FaChalkboardTeacher />,
            color: 'purple',
            bg: 'bg-purple-100',
            text: 'text-purple-600'
        },
        {
            title: 'Active Classes',
            value: stats.classes,
            icon: <FaLayerGroup />,
            color: 'orange',
            bg: 'bg-orange-100',
            text: 'text-orange-600'
        },
        {
            title: 'Monthly Revenue',
            value: `LKR ${Number(stats.monthly_revenue).toLocaleString()}`,
            icon: <FaMoneyBillWave />,
            color: 'green',
            bg: 'bg-green-100',
            text: 'text-green-600'
        }
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {cards.map((card, index) => (
                <div key={index} className="bg-white/60 backdrop-blur-xl rounded-2xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white/50 hover:bg-white/80 transition-all duration-300 transform hover:-translate-y-1">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">{card.title}</p>
                            <h3 className="text-2xl font-black text-gray-900 mt-2">{card.value}</h3>
                        </div>
                        <div className={`p-3 rounded-xl ${card.bg} ${card.text} text-xl shadow-sm`}>
                            {card.icon}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
